// Utility helpers to reduce nested ternaries and duplicated logic across pages.

export const ARTICLE_STATUS_COLORS = {
  PUBLISHED: 'bg-green-100 text-green-800',
  DRAFT: 'bg-gray-100 text-gray-800',
  PENDING: 'bg-yellow-100 text-yellow-800',
  REJECTED: 'bg-red-100 text-red-800',
  APPROVED: 'bg-blue-100 text-blue-800',
  ARCHIVED: 'bg-neutral-200 text-neutral-800',
};

export const getStatusColorClass = (status) =>
  ARTICLE_STATUS_COLORS[status] || 'bg-red-100 text-red-800';

export const USER_ROLE_COLORS = {
  SUPER_ADMIN: 'bg-purple-100 text-purple-800',
  ADMIN: 'bg-red-100 text-red-800',
  EDITOR: 'bg-blue-100 text-blue-800',
  REPORTER: 'bg-green-100 text-green-800',
  GUEST: 'bg-gray-100 text-gray-800',
};

export const getRoleColorClass = (role) =>
  USER_ROLE_COLORS[role] || 'bg-gray-100 text-gray-800';

export const PANEL_LABELS = {
  admin: 'Admin Panel',
  editor: 'Editor Panel',
  reporter: 'Reporter Panel',
};

export const getPanelLabel = (panelType) =>
  PANEL_LABELS[panelType] || 'Reporter Panel';

// Log helper that suppresses in production
export const devLog = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(...args);
  }
};
